import React, {lazy, Suspense} from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { isActive } from '../Core/Features/FeatureGlobal';
import PageHomeOut from '../Components/Pages/PageHomeOut/PageHomeOut';
import PageComunityRegister from '../Components/Pages/PageNetworking/PageCommunityNetworking/PageComunityRegister';

const PageLogin = lazy(()=>import('../Components/Pages/PageLogin/PageLogin'));
const PagePasswordRecovery = lazy(()=>import('../Components/Pages/PagePasswordRecovery/PagePasswordRecovery'));
const PageHomeIn = lazy(()=>import('../Components/Pages/PageHomeIn/PageHomeIn'));
const PageRegister = lazy(()=>import('../Components/Pages/PageRegister/PageRegister'));
const PageProfile = lazy(()=>import('../Components/Pages/PageProfile/PageProfile'));
const PageServices = lazy(()=>import('../Components/Pages/PageServices/PageServices'));
const PageHelp = lazy(()=>import('../Components/Pages/PageHelp/PageHelp'));
const PageHelpScheduling = lazy(()=>import('../Components/Pages/PageHelp/PageHelpScheduling'));
const PageBlog = lazy(()=>import('../Components/Pages/PageBlog/PageBlog'));
const PageBlogArticle = lazy(()=>import('../Components/Pages/PageBlog/PageBlogArticle'));
// Incapacidad total temporal
const PageIttServices = lazy(()=>import('../Components/Pages/PageIttServices/PageIttServices'));
const PageBranding = lazy(()=>import('../Components/Pages/PageBranding/PageBranding'));
const PageBrandingComunidad = lazy(()=>import('../Components/Pages/PageBranding/PageBrandingComunidad'));
const PageMenuNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageMenuNetworking/PageMenuNetworking'));
const PageEventNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageEventsNetworking/PageEventNetworking'));
const PageEventsNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageEventsNetworking/PageEventsNetworking'));
const PageSubscribedEventsNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageEventsNetworking/PageSubscribedEventsNetworking'));
const PageServiceNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageServiceNetworking/PageServiceNetworking'));
const PageCommunityNetworking = lazy(()=>import('../Components/Pages/PageNetworking/PageCommunityNetworking/PageCommunityNetworking'));
const PageLaboralAdvisory = lazy(()=>import('../Components/Pages/PageLaboralAdvisory/PageLaboralAdvisory'));
const PageSalary = lazy(()=>import('../Components/Pages/PageSalary/PageSalary'));
// Desempleo
const PageDesempleoServices = lazy(()=>import('../Components/Pages/PageDesempleoServices/PageDesempleoServices'));
const PageCurriculumMenu = lazy(()=>import('../Components/Pages/PageCurriculum/PageCurriculumMenu/PageCurriculumMenu'));
const PageCurriculumCreation = lazy(()=>import('../Components/Pages/PageCurriculum/PageCurriculumCreation/PageCurriculumCreation'));
const PageCurriculumScheduling = lazy(()=>import('../Components/Pages/PageCurriculum/PageCurriculumScheduling/PageCurriculumScheduling'));
const PageCurriculumImprovement = lazy(()=>import('../Components/Pages/PageCurriculum/PageCurriculumImprovement/PageCurriculumImprovement'));
const PageJoboffers = lazy(()=>import('../Components/Pages/PageJoboffers/PageJoboffers'));
const PageMenuInterview = lazy(()=>import('../Components/Pages/PageInterview/PageMenuInterview/PageMenuInterview'));
const PageOptionsInterview = lazy(()=>import('../Components/Pages/PageInterview/PageMenuInterview/PageOptionsInterview'));
const PageSchedulingInterview = lazy(()=>import('../Components/Pages/PageInterview/PageSchedulingInterview/PageSchedulingInterview'));
const PageResultsInterview = lazy(()=>import('../Components/Pages/PageInterview/PageResultsInterview/PageResultsInterview'));
const PageTestInterviewParts = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewParts/PageTestInterviewParts'));
const PageTestInterviewManagement = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewManagement/PageTestInterviewManagement'));
const PageTestInterviewNumbers = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewNumbers/PageTestInterviewNumbers'));
const PageTestInterviewLeadership = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewLeadership/PageTestInterviewLeadership'));
const PageTestInterviewPerception = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewPerception/PageTestInterviewPerception'));
const PageTestInterviewReasoning = lazy(()=>import('../Components/Pages/PageInterview/PageTestInterviewReasoning/PageTestInterviewReasoning'));
const PageLegalAdvisory = lazy(()=>import('../Components/Pages/PageLegalAdvisory/PageLegalAdvisory'));
const PageTributi = lazy(() => import('../Components/Pages/PageTributi/PageTributi'));
//Coursera
const PageCoursera = lazy(() => import('../Components/Pages/PageCoursera/PageCoursera'));
const PageInstafit = lazy(() => import('../Components/Pages/PageInstafit/PageInstafit'));


export const Routes = createBrowserRouter(
    isActive()?[
    {
        path:'*',
        element: <Suspense fallback={<div>...</div>}><PageHomeIn/></Suspense>     
    },
    {
        path:'/',
        element: <Suspense fallback={<div>...</div>}><PageHomeIn/></Suspense>     
    },
    {
        path:'/homein',
        element: <Suspense fallback={<div>...</div>}><PageHomeIn/></Suspense>     
    },
    {
        path:'/mi-perfil',
        element: <Suspense fallback={<div>...</div>}><PageProfile/></Suspense>     
    },
    {
        path:'/mis-servicios',
        element: <Suspense fallback={<div>...</div>}><PageServices/></Suspense>     
    },
    {
        path:'/centro-de-ayuda',
        element: <Suspense fallback={<div>...</div>}><PageHelp/></Suspense>     
    },
    {
        path:'/centro-de-ayuda-agendamiento',
        element: <Suspense fallback={<div>...</div>}><PageHelpScheduling/></Suspense>     
    },
    // Incapacidad total temporal
    {
        path:'/branding-digital',
        element: <Suspense fallback={<div>...</div>}><PageBranding/></Suspense>
    },
    {
        path:'/networking',
        element: <Suspense fallback={<div>...</div>}><PageMenuNetworking/></Suspense>
    },
    {
        path:'/eventos',
        element: <Suspense fallback={<div>...</div>}><PageEventsNetworking/></Suspense>
    },
    {
        path:'/eventos/inscritos',
        element: <Suspense fallback={<div>...</div>}><PageSubscribedEventsNetworking/></Suspense>
    },
    {
        path:'/eventos/:id',
        element: <Suspense fallback={<div>...</div>}><PageEventNetworking/></Suspense>
    },
    {
        path:'/eventos-inscritos',
        element: <Suspense fallback={<div>...</div>}><PageServiceNetworking/></Suspense>
    },
    {
        path:'/comunidad-emprendedores-agregar',
        element: <Suspense fallback={<div>...</div>}><PageBrandingComunidad/></Suspense>
    },
    {
        path:'/comunidad-emprendedores-editar',
        element: <Suspense fallback={<div>...</div>}><PageComunityRegister/></Suspense>
    },
    {
        path:'/comunidad-emprendedores',
        element: <Suspense fallback={<div>...</div>}><PageCommunityNetworking/></Suspense>
    },
    {
        path:'/orientacion-legal-laboral',
        element: <Suspense fallback={<div>...</div>}><PageLaboralAdvisory/></Suspense>
    },
    {
        path:'/comparador-salarial',
        element: <Suspense fallback={<div>...</div>}><PageSalary/></Suspense>
    },    
    // Desempleo
    {
        path:'/hoja-de-vida',
        element: <Suspense fallback={<div>...</div>}><PageCurriculumMenu/></Suspense>
    },
    {
        path:'/hoja-de-vida-creacion',
        element: <Suspense fallback={<div>...</div>}><PageCurriculumCreation/></Suspense>
    },
    {
        path:'/hoja-de-vida-agendamiento',
        element: <Suspense fallback={<div>...</div>}><PageCurriculumScheduling/></Suspense>
    },
    {
        path:'/hoja-de-vida-perfeccionamiento',
        element: <Suspense fallback={<div>...</div>}><PageCurriculumImprovement/></Suspense>
    },
    {
        path:'/ofertas-laborales',
        element: <Suspense fallback={<div>...</div>}><PageJoboffers/></Suspense>
    },
    {
        path:'/prepara-entrevistas-menu',
        element: <Suspense fallback={<div>...</div>}><PageOptionsInterview/></Suspense>
    },
    {
        path:'/prepara-entrevistas',
        element: <Suspense fallback={<div>...</div>}><PageMenuInterview/></Suspense>
    },
    {
        path:'/prepara-entrevistas-agenda',
        element: <Suspense fallback={<div>...</div>}><PageSchedulingInterview/></Suspense>
    },
    {
        path:'/prepara-entrevistas-resultados',
        element: <Suspense fallback={<div>...</div>}><PageResultsInterview/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-partes',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewParts/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-gestion',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewManagement/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-numeros',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewNumbers/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-liderazgo',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewLeadership/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-percepcion',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewPerception/></Suspense>
    },
    {
        path:'/prepara-entrevistas-prueba-razonamiento',
        element: <Suspense fallback={<div>...</div>}><PageTestInterviewReasoning/></Suspense>
    },
    {
        path:'/orientacion-legal',
        element: <Suspense fallback={<div>...</div>}><PageLegalAdvisory/></Suspense>
    },
    {
        path: '/orientacion-tributaria',
        element: <Suspense fallback={<div>...</div>}><PageTributi /></Suspense>
    },
    {
        path:'/blog',
        element: <Suspense fallback={<div>...</div>}><PageBlog/></Suspense>     
    },
    {
        path:'/blog-articulo-score-01',
        element: <Suspense fallback={<div>...</div>}><PageBlogArticle/></Suspense>     
    },
    {
        path:'/mis-servicios-itt',
        element: <Suspense fallback={<div>...</div>}><PageIttServices/></Suspense>     
    },
    {
        path:'/mis-servicios-desempleo',
        element: <Suspense fallback={<div>...</div>}><PageDesempleoServices/></Suspense>     
    },
    {
        path:'/coursera',
        element: <Suspense fallback={<div>...</div>}><PageCoursera/></Suspense>     
    },
    {
        path:'/instafit',
        element: <Suspense fallback={<div>...</div>}><PageInstafit/></Suspense>     
    },
]:[
    {
        path:'*',
        element: <PageHomeOut />     
    },
    {
        path:'/',
        element: <PageHomeOut />     
    },
    {
        path:'/registro',
        element: <Suspense fallback={<div>...</div>}><PageRegister/></Suspense>     
    },
    {
        path:'/inicia-sesion',
        element: <Suspense fallback={<div>...</div>}><PageLogin/></Suspense>     
    },
    {
        path:'/olvidaste-tu-contrasena',
        element: <Suspense fallback={<div>...</div>}><PagePasswordRecovery/></Suspense>     
    },
    {
        path:'/centro-de-ayuda',
        element: <Suspense fallback={<div>...</div>}><PageHelp/></Suspense>     
    },
]
);